import React from "react";
import { connect } from "react-redux";
import { format } from "date-fns";
import { Actions as TIMESHEET_IMPORT_ACTIONS } from "../../../store/actions/timesheetImportActions";
import WarningRow from "./WarningRow";
import { PencilSquareIcon } from "@heroicons/react/20/solid";
import { Link } from "react-router-dom";
import { getEmploymentTypeName } from "@/common/validation/Validators";

const TimesheetsOutsideOfRange = ({
	reference,
	employee,
	index,
	timesheetsOutsideOfRange,

	// ignore,
	// setIgnore,
	// processWarnings,
	// linkEmployee,
	// ignorePermanently,
}) => {
	const rowClass = index % 2 == 1 ? "odd" : "even";

	console.log("employee", employee);

	const agreementStart = employee?.engagementDate;
	const agreementEnd = employee?.terminationDate;

	console.log(agreementStart, agreementEnd);

	const trashOutOfRangeTimesheets = () => {
		//
		console.log("trashOutOfRangeTimesheets");
	};

	return [
		<tr
			key={reference}
			role="row"
			className={rowClass}
		>
			<td className="font-w600">{reference}</td>
			<td className="font-w600">
				{employee?.employeeName} {employee?.employeeSurname}{" "}
				{employee && getEmploymentTypeName({ employmentType: employee.employmentType, short: true })}
			</td>
			<td colSpan="2">{timesheetsOutsideOfRange.length} Timesheets Out of Range</td>
			<td colSpan="3">
				Employed: {agreementStart && format(new Date(agreementStart), "do MMM yyyy")}
				{agreementEnd && ` - ${format(new Date(agreementEnd), "do MMM yyyy")}`}
			</td>

			<td colSpan="1">
				<Link
					className="btn btn-xs btn-default"
					target="_blank"
					to={`/organisation/people/${employee?.id}`}
				>
					<PencilSquareIcon className="w-5 h-5" style={{ float: "left" }} />
				</Link>
				{/* <div className='btn btn-danger' onClick={trashOutOfRangeTimesheets}>
              <TrashIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
            </div> */}
			</td>
		</tr>,
		timesheetsOutsideOfRange.map((item) => (
			<WarningRow
				disableEditing={true}
				itemIndex={item.index}
				key={item.key}
				rowclassName={rowClass}
				setItem={(newItem) => {
					// const newData = [...data]
					// newData[warning.index] = newItem;
					// timesheetsPrepared(newData)
				}}
			/>
		)),
	];

	// <td colSpan='1'>
	//   <span className='btn' onClick={() => {
	//     const newCollapse = {...collapse}
	//     newCollapse[item.reference + warning.warningId] = !collapse[item.reference + warning.warningId]
	//     setCollapse(newCollapse);
	//   }}>{!collapse[item.reference + warning.warningId] ? <MinusCircleIcon style={{ height: "1.5em", float: "left" }} />:  <PlusCircleIcon style={{ height: "1.5em", float: "left" }} /> }</span>
	// </td>
};

const mapStateToProps = (state, ownProps) => {
	const reference = ownProps.reference;

	return {
		timesheetsOutsideOfRange: state.timesheetImport.timesheetsOutsideOfRange[reference],
		employee: state.employees.employeesByReference[reference],
		// data: state.timesheetImport.dataToSend,
	};
};

const mapDispatchToProps = (dispatch) => ({
	processWarnings: () => dispatch(TIMESHEET_IMPORT_ACTIONS.processWarnings()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetsOutsideOfRange);
